import { Map } from "mapbox-gl";
import { createContext, Ref } from "react";
export type MapContextType = {
    map: Map | null;
    mapContainerRef: Ref<HTMLDivElement>;
    mapLoaded: boolean;
    initializeMap: () => void;
};

export const MapContext = createContext<MapContextType | null>(null);
